<div class="sml-modal-dialog sml-modal-{{ size }} {{ modalClass }}">
  <div class="sml-modal-content {{ bodyClass }}" [ngClass]="{'max-md:!tw-h-[560px]': mobileFilters || fromReordering}">
    <ng-container *ngTemplateOutlet="mobilCloseButtonTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="closeButtonTemplate"></ng-container>
    <ng-container *ngIf="isFullScreen && isMobileView">
      <ng-content select="[subheader]"></ng-content>
    </ng-container>
    <div #scrollContent class="sml-modal-body-content {{customDialogBodySpacing}}" >
      <div class="sml-modal-content-inner sml-modal-header tw-flex tw-flex-col tw-items-start tw-justify-between tw-w-full" *ngIf="hasHeader">
        <div class="tw-flex tw-flex-col tw-items-stretch">
          @if (iconName) {
          <div class="tw-flex tw-justify-{{ iconPosition }}">
            <i-icon [name]="iconName" *ngIf="iconName" class="!tw-w-[100px] !tw-h-[100px]"></i-icon>
          </div>
          }
          <div class="tw-flex tw-flex-col tw-gap-1">
            <ng-container *ngIf="!isMobileView">
              <h4 class="tw-text-dark-grey-2 tw-text-2xl tw-font-bold tw-flex tw-justify-{{dialogTitlePosition}}" [innerHTML]="dialogTitle || 'Default Title'"
                [attr.aria-label]="dialogTitle || 'Default Title'">
                &nbsp;
              </h4>

            </ng-container>

            <div class="tw-text-mercury-950 tw-text-sm tw-font-medium tw-leading-relaxed tw-text-{{dialogHeaderContentPosition}}" [innerHTML]="dialogHeaderContent"></div>
          </div>
        </div>
        @if (hasCloseButton) {
        <a href="javascript:void(0);" class="tw-transition-all tw-flex hover:tw-text-alert-900" (click)="closeModal()">
          <i-icon [name]="'close'"></i-icon>
        </a>
        }
      </div>
      <div class="sml-modal-content-inner  sml-modal-body {{modalBodyClass}}">
        @if(hasConfirmationDialog){
        <ng-container *ngTemplateOutlet="confirmationDialogTemplate"></ng-container>
        }
        <ng-content></ng-content>
      </div>
    </div>
    <ng-content select="[footer]"></ng-content>
  </div>
</div>

<ng-template #mobilCloseButtonTemplate>
  @if(hasCloseButton){
    <button class="tw-bg-white !tw-p-0 tw-min-h-11 tw-min-w-11 tw-rounded-full tw-z-50 tw-absolute tw-top-0 tw-right-4 -tw-translate-y-14" (click)="closeModal()">
      <i-icon [name]="'x-mark'" class="!tw-w-4"></i-icon>
    </button>
  }
</ng-template>

<ng-template #closeButtonTemplate>
  @if(isMobileView && !isFullScreen && showCloseButtonOnMobile){
    <button class="tw-bg-white !tw-p-0 tw-min-h-11 tw-min-w-11 tw-rounded-full tw-z-50 tw-absolute tw-top-0 tw-right-4 -tw-translate-y-14" (click)="!mobileFilters ? closeModal() : closeModalMobile()" type="button" [ngClass]="{'tw-top-[85px] tw-min-h-7 tw-min-w-7':isCalledFomCampaignShare}">
      <i-icon [name]="'x-mark'" class="!tw-w-4"></i-icon>
    </button>
  }
</ng-template>

<ng-template #confirmationDialogTemplate>
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-7">
    <div class="tw-flex tw-justify-{{ iconPosition }}">
      <i-icon [name]="iconName" *ngIf="iconName" class="!tw-w-[100px] !tw-h-[100px]"></i-icon>
      <div *ngIf="src" >
        <img [src]="src" alt="" class="!tw-w-[100px] !tw-h-[100px]">
      </div>
    </div>
    <div class="tw-flex tw-flex-col tw-gap-2">
      <h4 class="tw-text-dark-grey-2 tw-text-2xl tw-font-bold tw-flex tw-justify-{{dialogTitlePosition}} tw-text-{{dialogTitlePosition}}">
        {{ dialogTitle }}
      </h4>
      <div class="tw-text-mercury-950 tw-text-sm tw-font-medium tw-leading-relaxed tw-text-{{dialogHeaderContentPosition}}" [innerHTML]="dialogHeaderContent"></div>
    </div>
  </div>
</ng-template>
